
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/infographic-templates",
      function () {
        return require("private-next-pages/infographic-templates/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/infographic-templates"])
      });
    }
  